// Extend as needed - like accepting separator height, color etc.
export default function HorizontalSectionSeparator(): React.JSX.Element {
  // TODO: Derive the color code from global palette (Design System)
  return <div className="h-[1px] my-6 bg-disabled opacity-30"></div>;
}
